const textStyles = {
  "heading-4xl": {
    fontSize: "heading-4xl",
    lineHeight: "heading-4xl",
    letterSpacing: "heading-4xl",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-3xl": {
    fontSize: "heading-3xl",
    lineHeight: "heading-3xl",
    letterSpacing: "heading-3xl",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-2xl": {
    fontSize: "heading-2xl",
    lineHeight: "heading-2xl",
    letterSpacing: "heading-2xl",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-xl": {
    fontSize: "heading-xl",
    lineHeight: "heading-xl",
    letterSpacing: "heading-xl",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-lg": {
    fontSize: "heading-lg",
    lineHeight: "heading-lg",
    letterSpacing: "heading-lg",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-md": {
    fontSize: "heading-md",
    lineHeight: "heading-md",
    letterSpacing: "heading-md",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-sm": {
    fontSize: "heading-sm",
    lineHeight: "heading-sm",
    letterSpacing: "heading-sm",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-xs": {
    fontSize: "heading-xs",
    lineHeight: "heading-xs",
    letterSpacing: "heading-xs",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "heading-2xs": {
    fontSize: "heading-2xs",
    lineHeight: "heading-2xs",
    letterSpacing: "heading-2xs",
    fontFamily: "heading",
    fontWeight: "medium"
  },
  "body-xl": {
    fontSize: "body-xl",
    lineHeight: "body-xl",
    letterSpacing: "body-xl",
    fontFamily: "body",
    fontWeight: "regular"
  },
  "body-lg": {
    fontSize: "body-lg",
    lineHeight: "body-lg",
    letterSpacing: "body-lg",
    fontFamily: "body",
    fontWeight: "regular"
  },
  "body-md": {
    fontSize: "body-md",
    lineHeight: "body-md",
    letterSpacing: "body-md",
    fontFamily: "body",
    fontWeight: "regular"
  },
  "body-sm": {
    fontSize: "body-sm",
    lineHeight: "body-sm",
    letterSpacing: "body-sm",
    fontFamily: "body",
    fontWeight: "regular"
  },
  "body-xs": {
    fontSize: "body-xs",
    lineHeight: "body-xs",
    letterSpacing: "body-xs",
    fontFamily: "body",
    fontWeight: "regular"
  }
};

export { textStyles };
